<template>
  <div class="w-chat__gift" :class="{'alert-danger': fullWidth}">
    <div class="gift__grid">
      <div v-for="gift in gifts" @click="send(gift.id)" class="gift__box">
        <div class="gift__image" v-bind:style="{'background-image': 'url(' + gift.url + ')'}">
          <div class="gift__price">
            {{ gift.price }} <i class="demo-icon icon-n-lova-coins"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GiftGalleryMixin from '../../../front/components/Chat/GiftGalleryMixin';

export default {
  name: 'GiftGallery',
  mixins: [GiftGalleryMixin],
  components: {},
  props: {
    fullWidth: {},
  },
};
</script>
